import { setDefaultStyle } from "apparatus/draw";
import { P } from "apparatus/library/common";
import { CompoundPath, Group } from "paper";
import { CommonCondenser, condenserCaseShape } from "../condensers";
export class FractionatingColumn2 {
    render(appearance) {
        const { height } = appearance;
        const { group: casing, snap: snapping } = condenserCaseShape(height, 15, "top-only");
        const inside = new CompoundPath({});
        inside.moveTo(P(0, 45));
        inside.lineTo(P(0, height - 20));
        const width = 20;
        for (let y = 55; y < height - 25; y += 18) {
            inside.moveTo(P(-width / 2, y));
            inside.lineTo(P(width / 2, y));
        }
        let graphic = new Group([casing, inside]);
        setDefaultStyle(graphic);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            snapping,
            pivot: P(0, height / 2)
        };
    }
}
FractionatingColumn2.properties = {
    label: "Fractionating Column",
    flippable: true,
    defaultAppearance: Object.assign(Object.assign({}, CommonCondenser.NoPorts.defaultAppearance), { height: 270 }),
    appearanceSpecs: [
        ...CommonCondenser.NoPorts.appearanceSpecs,
    ],
};
